import { Environment } from './environment.models';

export const environment: Environment = {
  backendUrl: 'https://www.backcourt-software.de/api/api',
  deploymentUser: 'root',
  deploymentServer: 'h2895108.stratoserver.net',
  deploymentPath: 'httpdocs/website/alpha/',
  environment: 'production',
  frontendUrl: 'https://www.backcourt-software.de/app',
  serverUrl: 'https://www.backcourt-software.de',
  landingUrl: 'https://www.backcourt-software.de',
  subscriptionsUrl: 'https://www.backcourt-software.de/plans',
  production: true,
};
